<template>
    <div class="ns-production">
        <el-card class="box-card">
            <div class="sub-menu-section">
                <div class="flex">
                    <div class="tab-link cursor-pointer" :class="{ 'active-tab-link': active_tab_link == 'production' }"
                        @click="setActiveTabLink('production')">
                        PRODUCTION
                    </div>
                    <div class="tab-link cursor-pointer ml-6" style="position: relative;"
                        :class="{ 'active-tab-link': active_tab_link == 'setup' }" @click="setActiveTabLink('setup')">
                        SETUP
                    </div>
                </div>
            </div>
            <!-- Production Main header -->
            <div class="mt-6 flex items-center justify-between">
                <div class="flex items-center">
                    <div>
                        <label>Location</label>
                        <el-select v-model="selected_location" placeholder="Select store" name="Select Store" size="medium"
                            class="store-input capitalize" filterable @change="selectLocation()" style="width: 270px;">
                            <el-option v-for="loc in location_list" :key="loc.id" :value="loc.id" :label="loc.name"
                                class="capitalize"></el-option>
                        </el-select>
                    </div>

                    <div v-if="active_tab_link == 'production'" class="ml-6">
                        <label>Date</label>
                        <el-date-picker v-model="selected_date" type="date" size="medium" placeholder="Select date"
                            style="width: 200px;" @change="changeDate()">
                        </el-date-picker>
                    </div>

                    <div v-if="active_tab_link == 'production'" class="ml-6">
                        <label>Production Setup</label>
                        <el-select v-model="selected_production" placeholder="Select Production Setup" multipleiple="Select Production Setup"
                            size="medium" class="store-input capitalize" filterable style="width: 270px;" @change="changeStation()">
                            <el-option v-for="pod in computedProdStation" :key="pod.id" :value="pod.id" :label="pod.name"
                                class="capitalize"></el-option>
                        </el-select>
                    </div>

                    <div v-if="active_tab_link == 'production'" class="ml-6">
                        <label>Day Parts</label>
                        <el-select v-model="selected_day_parts" placeholder="Select Day Parts" multiple collapse-tags filtrable clearable name="Select Day Parts"
                            size="medium" class="store-input capitalize" filterable style="width: 270px;" @change="changeDayParts()">
                            <el-option v-for="dp in day_parts_data" :key="dp.id" :value="dp.id" :label="dp.day_part_name"
                                class="capitalize"></el-option>
                        </el-select>
                    </div>

                    <!-- <div v-if="active_tab_link == 'production'" class="ml-6">
                        <label>&nbsp;</label>
                        <el-button class="ns-button" @click="generatePLSPdf">Generate PLS PDF</el-button>
                    </div> -->

                    <!-- <div v-if="active_tab_link == 'production'" class="ml-6">
                        <label>Item Category</label>
                        <el-select v-model="selected_category" placeholder="Select store" name="Select Store" size="medium"
                            class="store-input capitalize" filterable>
                            <el-option v-for="cat in category_list" :key="cat.id" :value="cat.id" :label="cat.name"
                                class="capitalize"></el-option>
                        </el-select>
                    </div> -->
                </div>
                <div class="flex items-center">
                    <!-- <p v-if="next_update_remaining_time" class="mr-3 mt-2 font-semibold">
                        Next Update In: &nbsp;
                        <span class="text-white bg-amp px-3 py-2" style="border-radius: 90px;">{{ next_update_remaining_time }}</span>
                    </p>

                    <i v-if="is_speech_playing" class="el-icon-video-pause ml-3 text-3xl cursor-pointer mt-2 text-amp font-bold" @click="pauseSpeech"></i>
                    <i v-else class="el-icon-video-play ml-3 text-3xl cursor-pointer mt-2 text-amp font-bold" @click="playSpeech"></i> -->

                    <div  class="ml-6">
                        <label>Search</label>
                        <el-input v-model="search_data" placeholder="Search by name" style="width: 280px;">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
            </div>
            <!-- Production Main content -->
            <div v-if="active_tab_link == 'production'" class="ns-production-sec mt-6 ns-pls-table">
                <div v-loading="forecast_tbl_loading" class="ns-table">
                    <table v-if="all_query_data.length && computedProductionData.length" class="ns-production-table" id="productionTable">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th v-for="pr_head in computedDayPartHeader" :key="pr_head.start_time" :colspan="pr_head.colSpan" :style="{backgroundColor: pr_head.day_part_color}">
                                    <span class="px-2 py-1 text-black rounded">{{ pr_head.day_part_name }}</span>
                                </th>
                            </tr>
                            <tr class="ns-prod-forecast-head-cell-1">
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th class="ns-cell-fix-02">PLS Level</th>
                                <th v-for="pr_head in computedProdHeader" :key="pr_head.id" :style="{backgroundColor: pr_head.day_part_color}">
                                    <span class="px-2 py-1 text-white rounded" :style="'background-color:'+ pr_head.bg_color">{{ pr_head.level }}</span>
                                </th>
                            </tr>
                            <tr class="ns-prod-forecast-head-cell-2">
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th class="ns-cell-fix-02">Transactions</th>
                                <th v-for="pr_head in computedProdHeader" :key="pr_head.id" :style="{backgroundColor: pr_head.day_part_color}">{{ pr_head.transaction }}</th>
                            </tr>
                            <tr class="ns-prod-forecast-head-cell-3">
                                <th style="width: 260px">Product</th>
                                <th>Holding Time</th>
                                <th>Slots</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th class="ns-cell-fix-02">&nbsp;</th>
                                <th v-for="pr_head in computedProdHeader" :id="'head-th-cell-'+pr_head.time" :key="pr_head.id" :style="{backgroundColor: pr_head.day_part_color}">{{ pr_head.time }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in computedProductionData" :key="item.id">
                                <td>
                                    {{ item.article_name }} <br>
                                    <div class="my-2 font-semibold">Forecast Qty - {{ item.item_qty }}</div>

                                </td>
                                <td> {{ item.holding_time }} </td>
                                <td> {{ item.number_of_slots }} </td>
                                <td class="text-center">
                                    <span class="font-semibold">Max/Pan</span> <br>
                                    <div class="my-2 font-semibold"> {{ item.max_quantity_per_tray }} </div>
                                </td>
                                <td>
                                    <div class="mb-2 font-semibold"> Forecast Qty </div>
                                    <span class="font-semibold"> Total Stock </span> <br>
                                    <div class="my-2 font-semibold"># of pans</div>
                                </td>
                                <td v-for="pr_head in computedProdHeader" :id="'head-td-cell-'+pr_head.time" :key="pr_head.id" :style="{backgroundColor: pr_head.day_part_color}">
                                    <div class="mb-2 font-semibold"> {{ getProdSetupDataByDateKey('quantity', item.article_id, pr_head.actual_datetime) }} </div>
                                    <span class="font-semibold"> {{ getProdSetupDataByDateKey('stock_level', item.article_id, pr_head.actual_datetime) }} </span> <br>
                                    <div class="my-2 font-semibold"> {{ getProdSetupDataByDateKey('number_of_trays', item.article_id, pr_head.actual_datetime) }} </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- If data is empty -->
                    <div v-else class="ns-empty-data">
                        <!-- <img src="../../assets/icons/empty_data_icon.png" alt="empty data"> -->
                        <el-empty description="No data available"></el-empty>
                    </div>
                </div>
            </div>
            <!-- Production setup -->
            <div v-if="active_tab_link == 'setup'" class="ns-production-sec-2 mt-12">
                <div class="flex items-center">
                    <div class="mt-3 mb-5">
                        <el-button  class="ns-button" @click="clickOnAddNew"><i class="el-icon-circle-plus-outline font-bold text-lg"></i> Add New Setup</el-button>
                    </div>
                    <div class="mt-3 mb-5 ml-4">
                        <el-button  class="ns-button" @click="clickOnAddNewStation"><i class="el-icon-circle-plus-outline font-bold text-lg"></i> Add New Station</el-button>
                    </div>
                </div>
                <div v-loading="setup_tbl_loading" class="event-table">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <span>Item Name</span>
                                    <el-popover
                                        placement="bottom"
                                        width="250"
                                        trigger="click">
                                        <img slot="reference" src="@/assets/icons/filter-filled-tool-symbol.png" alt="filter" class="ml-2 mt-2 cursor-pointer" style="width: 12px">
                                        <!-- Filter -->
                                        <el-select v-model="filter_article" placeholder="Select article" name="Select article"
                                            size="mini" class="store-input capitalize" multiple filterable collapse-tags clearable style="width: 100%">
                                            <el-option v-for="art in computedArticles" :key="art.id" :value="art.id"
                                                :label="art.name" class="capitalize"></el-option>
                                        </el-select>
                                    </el-popover>
                                </th>
                                <th>
                                    <span>Production Station</span>
                                    <el-popover
                                        placement="bottom"
                                        width="250"
                                        trigger="click">
                                        <img slot="reference" src="@/assets/icons/filter-filled-tool-symbol.png" alt="filter" class="ml-2 mt-2 cursor-pointer" style="width: 12px">
                                        <!-- Filter -->
                                        <el-select v-model="filter_production_station" placeholder="Select Production Station" name="Select Production Station"
                                            size="mini" class="store-input capitalize" multiple filterable collapse-tags clearable style="width: 100%">
                                            <el-option v-for="prd in computedSearchProdStation" :key="prd.id" :value="prd.id"
                                                :label="prd.name" class="capitalize"></el-option>
                                        </el-select>
                                    </el-popover>
                                </th>
                                <th>Holding time</th>
                                <th>Maximum Patties / Tray</th>
                                <th>No. of Slots</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, item_index) in productionSetupData" :key="item.id">
                                <template v-if="item.is_editable">
                                    <td>
                                        <el-select v-model="item.article_id" disabled placeholder="Select article" name="Select article"
                                            size="mini" class="store-input capitalize" filterable @change="updateArticle(item_index, item.article_id)">
                                            <el-option v-for="art in store_articles" :key="art.id" :value="art.id"
                                                :label="art.name" class="capitalize"></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-select v-model="item.production_station_id" placeholder="Select Production Station" name="Select Production Station"
                                            size="mini" class="store-input capitalize" filterable @change="updateStation(item_index, item.production_station_id)">
                                            <el-option v-for="prd in computedProdStation" :key="prd.id" :value="prd.id"
                                                :label="prd.name" class="capitalize"></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-time-picker :value="item.time" size="mini" :picker-options="pickerOptions"
                                            :format="customFormat" name="Select Holding Time" style="width: 80%;"
                                            placeholder="Select Holding Time" :clearable="true" @input="(newTime) => updateTime(item_index, newTime)"></el-time-picker>
                                    </td>
                                    <td>
                                        <el-input-number v-model="item.max_quantity_per_tray" size="mini" name="Patties / Tray"
                                            :min="1" :max="300" @change="$forceUpdate()"></el-input-number>
                                    </td>
                                    <td>
                                        <el-input-number v-model="item.number_of_slots" name="Slots" size="mini" :min="1"
                                            :max="100" @change="$forceUpdate()"></el-input-number>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{ item.article || item.article_name }}</td>
                                    <td>{{ item.production_station || item.production_station }}</td>
                                    <td>{{ moment(item.holding_time, 'HH:mm:ss').format('HH:mm') }}</td>
                                    <td>{{ item.max_quantity_per_tray }}</td>
                                    <td>{{ item.number_of_slots }}</td>
                                </template>
                                <td>
                                    <div v-if="item.is_editable" class="flex items-center">
                                        <el-button size="mini" class="mr-4 ns-mini-button" @click="saveSetupRecord(item_index)"> Save </el-button>
                                        <el-button size="mini" class="mr-4" @click="revertOldRecord(item.id, item_index)"> Cancel </el-button>
                                    </div>
                                    <div v-else class="flex items-center">
                                        <img v-if="!item.is_editable" src="../../assets/icons/edit_pencil_icon.png" class="mr-4" alt="edit" @click="editAction(item_index,item.id)">
                                        <img  v-if="!item.is_editable" src="../../assets/icons/delete_icon-2.png" alt="delete" @click="deleteSetupRecord(item.id)">
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-card>


        <!-- Add new setup -->
        <el-dialog title="Add Production Setup" :visible.sync="add_new_prod_setup" custom-class="ns-dialog" :width="'40%'"
            :before-close="handleClose">
            <template>
                <!-- Training form -->
                <el-row :gutter="15">
                    <el-col :span="12">
                        <template v-if="!is_add_new_station_mode">
                            <p class="text-sm font-semibold my-2">Select Production Station <span style="color: red">*</span></p>
                            <el-select v-model="selected_production_station" v-validate="add_new_prod_setup && 'required'" placeholder="Select Production Station"
                                name="Select Production Station" class="w-full" filterable>
                                <!-- <div class="px-4 py-3 text-amplitude font-semibold cursor-pointer text-sm" @click="handleNewStationMode()">Add New Station</div> -->
                                <el-option v-for="item in computedProdStation" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <p>
                                <span :v-show="errors.has(`Select Production Station`)" class="text-red-dark text-xs">
                                    {{ errors.first(`Select Production Station`) ? 'Required field' : '' }}
                                </span>
                            </p>
                        </template>
                        <template v-else>
                            <p class="text-sm font-semibold my-2">Add New Station <span style="color: red">*</span></p>
                            <div class="flex items-center">
                                <el-input v-model="new_station_name" v-validate="add_new_prod_setup && 'required|max:25'" placeholder="Enter Station Name" name="New Station Name" :maxlength="25" show-word-limit class="mr-5 ns-input-pr"></el-input>
                                <el-button class="ns-button ml-3" size="mini" type="primary" @click="saveNewStation"> Save </el-button>
                                <el-button class="ns-cancel-button" size="mini" @click="handleNewStationMode()"> Cancel </el-button>
                            </div>
                            <p>
                                <span :v-show="errors.has(`New Station Name`)" class="text-red-dark text-xs">
                                    {{ errors.first(`New Station Name`) }}
                                </span>
                            </p>
                        </template>
                    </el-col>
                    <el-col :span="12">
                        
                    </el-col>
                </el-row>
                <el-row :gutter="15" class="mt-4">
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Select Article <span style="color: red">*</span></p>
                        <el-select v-model="selected_article_id" v-validate="add_new_prod_setup && 'required'" placeholder="Select article"
                            name="Select article" class="w-full" filterable clearable>
                            <el-option v-for="item in computedArticles" :key="item.id" :disabled="item.is_added" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                        <p>
                            <span :v-show="errors.has(`Select article`)" class="text-red-dark text-xs">
                                {{ errors.first(`Select article`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Select Holding Time <span style="color: red">*</span></p>
                        <el-time-picker v-model="selected_holding_time" v-validate="add_new_prod_setup && 'required'"
                            :picker-options="pickerOptions" :format="customFormat" name="Select Holding Time"
                            style="width: 100%;" placeholder="Select Holding Time" :clearable="true"></el-time-picker>
                        <p>
                            <span :v-show="errors.has(`Select Holding Time`)" class="text-red-dark text-xs">
                                {{ errors.first(`Select Holding Time`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                </el-row>
                <el-row :gutter="15" class="mt-4">
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Patties / Tray <span style="color: red">*</span></p>
                        <el-input-number v-model="selected_tray" name="Patties / Tray" :min="1"
                            :max="300"></el-input-number>
                        <p>
                            <span :v-show="errors.has(`Patties / Tray`)" class="text-red-dark text-xs">
                                {{ errors.first(`Patties / Tray`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Slots <span style="color: red">*</span></p>
                        <el-input-number v-model="selected_slots" name="Slots" :min="1" :max="100"></el-input-number>
                        <p>
                            <span :v-show="errors.has(`Slots`)" class="text-red-dark text-xs">
                                {{ errors.first(`Slots`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                </el-row>

                <span slot="footer" class="dialog-footer">
                    <el-button class="ns-cancel-button" @click="add_new_prod_setup = false">Cancel</el-button>
                    <el-button class="ns-button" @click="addNewStoreSetup">Save</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- Add new setup -->
        <!-- Add new station -->
        <el-dialog title="Add Production Station" :visible.sync="add_prod_station_popup" custom-class="ns-dialog" :width="'40%'"
            :before-close="handleClose">
            <template v-loading="station_loading" >
                <!-- Training form -->
                <el-row :gutter="15">
                    <el-col :span="12">
                        <template>
                            <p class="text-sm font-semibold my-2">Select Production Station <span style="color: red">*</span></p>
                            <el-select v-model="production_station_id" v-validate="add_prod_station_popup && 'required'" placeholder="Select Production Station"
                                name="Select Production Station 2" class="w-full" filterable @change="handleStationChange">
                                <el-option v-for="item in production_station_list" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <p>
                                <span :v-show="errors.has(`Select Production Station 2`)" class="text-red-dark text-xs">
                                    {{ errors.first(`Select Production Station 2`) ? 'Required field' : '' }}
                                </span>
                            </p>
                        </template>
                    </el-col>
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Number of stations<span style="color: red">*</span></p>
                        <el-input-number v-model="number_of_stations" name="Number of station" :min="1"
                            :max="5"></el-input-number>
                        <p>
                            <span :v-show="errors.has(`Number of station`)" class="text-red-dark text-xs">
                                {{ errors.first(`Number of station`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                </el-row>
                <!-- <el-row :gutter="15" class="mt-4">
                    <el-col :span="24">
                        <p class="text-sm font-semibold my-2">Station Name <span style="color: red">*</span></p>
                        <el-input v-model="new_station_name" v-validate="add_prod_station_popup && 'required|max:30'" placeholder="Enter Station Name" name="New Station Name" :maxlength="30" show-word-limit class="mr-5" style="width: 100%"></el-input>
                        <p>
                            <span :v-show="errors.has(`New Station Name`)" class="text-red-dark text-xs">
                                {{ errors.first(`New Station Name`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                </el-row> -->
                <el-row :gutter="15" class="mt-4">
                    <el-col :span="12">
                        <p class="text-sm font-semibold my-2">Active <span style="color: red">*</span></p>
                        <el-switch v-model="is_station_active" name="Active" :min="1"
                            :max="300"></el-switch>
                        <p>
                            <span :v-show="errors.has(`Active`)" class="text-red-dark text-xs">
                                {{ errors.first(`Active`) ? 'Required field' : '' }}
                            </span>
                        </p>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button class="ns-cancel-button" @click="add_prod_station_popup = false">Cancel</el-button>
                    <el-button class="ns-button" @click="saveNewStation">Save</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- Add new station -->
    </div>
</template>

<script>
import {ProductionMixin} from '../../../mixins/productionMixin.js';
export default {
    name: 'ProductionDashboard',
    mixins: [ProductionMixin],
    created() {
        this.getDayPartData();
    },
    mounted() {
        this.getLocationList();
        this.getProdSegments();
        // Add dummy data in production header
        // for (const elm of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29]) {
        //     this.production_header.push({
        //         id: elm,
        //         level: 'Level ' + elm,
        //         transaction: Math.floor(Math.random() * 10),
        //         time: '11:00',
        //     });
        //     this.production_data.push({
        //         id: elm,
        //         value: Math.floor(Math.random() * 10),
        //     });
        // }

        setTimeout(() => {
            // this.runAtEveryDynamicInterval(30);
        }, 7000);
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/productions.scss";
</style>

<style>

.ns-production .el-switch.is-checked .el-switch__core {
    border-color: #e29d5a !important;
    background-color: #e29d5a !important;
}

.el-input__inner {
    text-transform: capitalize;
}

.ns-dialog .el-dialog__header {
    background: #fdfdfd;
    color: #1c1b1b;
    padding: 25px 20px;
    border-radius: 8px;
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 700;
}

.ns-dialog .el-dialog__footer {
    /* position: fixed; */
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
    border-radius: 8px;
}

.ns-dialog .el-dialog__body {
    padding: 5px 20px 30px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.ns-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-weight: 600;
    font-size: 25px;
}
.ns-input-pr .el-input__inner{
    width: 250px;
}
</style>